import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import {GlossaryDispatch} from '../index';
import style from './style.module.scss';

const GLOSSARY_ITEM_TYPE = {
  VALUE: 'value',
  TITLE: 'title',
};

/**
 * GlossaryListing:
 *   - List fo all items to display in GlossaryList.
 */
export function GlossaryListing(props) {
  const renderGlossaryItem = (glossaryItem) => {
    if (glossaryItem.type === GLOSSARY_ITEM_TYPE.TITLE) {
      return (
        <GlossaryTitleItem key={glossaryItem.id} title={glossaryItem.title} />
      );
    } else {
      return (
        <GlossaryValueItem
          key={glossaryItem.id}
          id={glossaryItem.id}
          title={glossaryItem.title}
          selected={glossaryItem.selected}
        />
      );
    }
  };

  const sorted = props.glossaryList.sort(function(a, b) {
    const FIRST_CHARACTER_INDEX = 0;
    const SECOND_CHARACTER_INDEX = 1;
    let textA = a.title[FIRST_CHARACTER_INDEX] === "_" ? a.title[SECOND_CHARACTER_INDEX].toUpperCase() : a.title[FIRST_CHARACTER_INDEX].toUpperCase();
    let textB = b.title[FIRST_CHARACTER_INDEX] === "_" ? b.title[SECOND_CHARACTER_INDEX].toUpperCase() : b.title[FIRST_CHARACTER_INDEX].toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});


console.log('$$$$');
console.log('$$$$');
console.log('$$$$');
console.log('$$$$');
console.log('$$$$');
console.log('$$$$');
console.log(sorted);
console.log('$$$$');

console.log('$$$$');

  return (
    <ul className={style.glossaryList}>
      {sorted.map(renderGlossaryItem)}
    </ul>
  );
}

GlossaryListing.propTypes = {
  /**
   * List of glossaryItems to be displayed in list
   */
  glossaryList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      type: PropTypes.oneOf(['value', 'title']),
    })
  ),
};

GlossaryListing.defaultProps = {
  glossaryList: [],
  loading: false,
  error: false,
};

/**
 * GlossaryValueItem
 *  - The glossary item that display at particular entity
 *  - on clicking the Item its details will be rendered in
 */
function GlossaryValueItem(props) {
  const {onSelectItem} = React.useContext(GlossaryDispatch);

  const onClick = (event) => {
    event.preventDefault();
    onSelectItem(props.id);
  };

  const getClassName = () => {
    return props.selected
      ? style.glossaryList_valueItemSelected
      : style.glossaryList_valueItem;
  };

  const item = useRef();

  useEffect(() => {
    if(props.selected && item.current){
      //item.current.scrollIntoView();
      item.current.parentNode.scrollTop = item.current.offsetTop - 8;
    }
  }, [props.selected, item.current])
  return (
    <li className={getClassName()} onClick={onClick} ref={item}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.title.replace("\\_", "_")}</ReactMarkdown>
    </li>
  );
}

GlossaryValueItem.propTypes = {
  /**
   * Unique id for the option
   */
  id: PropTypes.number.isRequired,
  /**
   * title of the option
   */
  title: PropTypes.string.isRequired,
  /**
   * Boolean specifying if the options is selected
   */
  selected: PropTypes.bool.isRequired,
};

GlossaryValueItem.defaultProps = {
  id: 0,
  title: '',
  selected: false,
};

/**
 * GlossaryTitleItem
 *  - The Glossary Item that display the title  category
 */
function GlossaryTitleItem(props) {
  return <li className={style.glossaryList_titleItem}>{props.title}</li>;
}

GlossaryTitleItem.propTypes = {
  /**
   * title of the option
   */
  title: PropTypes.string.isRequired,
};

GlossaryValueItem.defaultProps = {
  title: '',
};
